export default {"id":"b7b21e8a","attrs":{"viewBox":"0 0 28 28","width":"24","height":"24"}}